export const environment = {
  version: 'v1.21.0',
  production: false,
  name: "dev",
  mocked: false,
  serviceBaseUrl: 'https://internal-tools.dev-k8s.rappipay.com',
  serviceBaseUrlMX: 'https://internal-tools.dev-k8s.rappipay.com.mx',
  externalServiceBaseUrl: 'https://services.dev-k8s.rappipay.com',
  serviceMockedUrl: 'https://cc-mock-services.herokuapp.com',  
  auth0: {
    /** El dominio dentro del tenant en Auth0 */
    domain: "rpp-customer-care-dev.us.auth0.com",
    clientId: "HrHklo6s2V0WgwWbv0qQYz8CKGeqexvI",
    /** Para que audiencia vamos a solicitar la emisión del token de acceso */
    audience: "rpp-customer-care-api",
    redirectUri: window.location.origin,
    errorPath: "/auth/authentication-error",    
      /** Las URLs que queremos agregarle el header de autenticación */
      allowedList: [
        'http://localhost:3000/*',
        'https://cc-mock-services.herokuapp.com/*',
        `https://internal-tools.dev-k8s.rappipay.com/*`,
        `https://services.dev-k8s.rappipay.com/*`,
        `https://internal-tools.dev-k8s.rappipay.com.mx/*`
      ],
    
  },
  externalUris: {
    lupe: 'https://lupe.dev.rappi.com',
    customerCareMx: 'https://customer-care.dev-k8s.rappipay.com.mx',
  },
  otherUris: {
    rppTwilioUrl: 'https://collection.dev-k8s.rappipay.com',
  },
  amplitude: {
    clientId: 'cf272a58d98163d5d3c57ccd3237088c',
    appKey: 'CCTEST'
  },
  split: {
    key: '1kjctdnk2n3on1mujle7o72o68uuqoibupml',
  },
  dispersion: {
    key: '4oacbsh7mgeu9je4od8g8ugo8v'
  },
   flags: {
    account: {
      actions: {
        blockEnabled: true,
        unblockEnabled: true,
        exonerationEnabled: true,
        cancelEnabled: true,
        certificateEnabled: true,
        withdrawEnabled: true,
      },
    },
    contract:{
      actions: {
        certificatedEnabled: true,
        cancelEnabled: true,
        blockEnabled: true,
        unblockEnabled: true,
      }
    },
    card: {
      actions: {
        freezeEnabled: true,
        replaceEnabled: true,
        restartResendEnabled: true,
      },
      validation: {
        expirationWarningMonths: 2
      }
    }
  },
};
